import React from 'react';
import MemberTypeForm from '../components/MemberTypeForm'

import axios from 'axios'
import { Table, Input, Button,Collapse,Select,Popover,Popconfirm,message,Spin,Tabs,Form, Card, Alert, DatePicker, Tooltip } from 'antd';
import moment from 'moment';

import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,FundViewOutlined,LoadingOutlined,EditOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import * as serverconfig from '../serverconn'
var CryptoJS = require("crypto-js");
const { TabPane } = Tabs;
const FormItem=Form.Item;

const { Panel } = Collapse;
const { Option } = Select;

const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

function callback(key) {
  console.log(key);
}

var sacco= ''
var token= ''
var username= ''

const MONTH_OPTIONS = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
];

function formatScheduledDueDate(record) {
  if (record.charge_mode !== 'scheduled') {
    return '-';
  }
  const month = parseInt(record.due_month, 10);
  const day = parseInt(record.due_day, 10);
  if (!month || !day) {
    return 'Not set';
  }
  const monthLabel = MONTH_OPTIONS.find((item) => item.value === month)?.label || month;
  return `${String(day).padStart(2, '0')} ${monthLabel} (every year)`;
}

function formatScheduledRunSummary(summary) {
  const parts = [
    `${summary.charged || 0} charged`,
    `${summary.members_checked || 0} members checked`,
    `${summary.skipped_paid || 0} already paid`,
    `${summary.skipped_balance || 0} insufficient balance`,
    `${summary.skipped_not_due || 0} not due today`,
    `${summary.errors || 0} errors`,
  ];
  let text = parts.join(', ');
  if ((summary.members_checked || 0) === 0 && (summary.skipped_not_due || 0) > 0) {
    text += '. The due date on your rule does not match today — use Force run to test off-schedule, or set the due date to today.';
  } else if ((summary.members_checked || 0) === 0 && (summary.rules_checked || 0) > 0) {
    text += '. No eligible members found for the configured member type (halted accounts are excluded).';
  }
  if (summary.info_messages && summary.info_messages.length) {
    text += ` ${summary.info_messages.join(' ')}`;
  }
  if (summary.error_messages && summary.error_messages.length) {
    text += ` ${summary.error_messages.join('; ')}`;
  }
  return text;
}

function autopaymentBusinessKey(item) {
  return [
    item.charge_mode || 'on_deposit',
    item.account_tocredit || '',
    item.member_type || '',
    item.payment_occurance || '',
  ].join('|');
}

function scheduledDueDateFromParts(dueMonth, dueDay) {
  const month = parseInt(dueMonth, 10);
  const day = parseInt(dueDay, 10);
  if (!month || !day) {
    return null;
  }
  const year = new Date().getFullYear();
  return moment(`${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`, 'DD/MM/YYYY');
}

class MemberTypeList extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    membertypes: [],
    datarequested:true,
    autopaymentlist:[],
    companyprofile:{},
    account_tocredit:'',
    totalpayment:0,
    companyaccounts:[],
    payment_occurance:'oneoff',
    member_type:'',
    charge_mode:'on_deposit',
    due_month:null,
    due_day:null,
    scheduled_due_date:null,
    payment_label:'',
    running_scheduled:false,
    editing_autopayment_key:null,

    extra_deposit_list:[],


  };

  componentDidMount(){

    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
    }else{
       sacco= ''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    if(localStorage.getItem("username")){
      username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
    }else{
      username= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccosedit/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

        console.log("List: "+String(res.data.extra_deposit_list))
        //set auto paylist
        this.setState({
          autopaymentlist: (res.data.automated_memberpayments_fromsavings===undefined || res.data.automated_memberpayments_fromsavings===null
            ? []
            : JSON.parse(res.data.automated_memberpayments_fromsavings)
          ).map((item, index) => ({
            ...item,
            charge_mode: item.charge_mode || 'on_deposit',
            due_month: item.due_month ? parseInt(item.due_month, 10) : null,
            due_day: item.due_day ? parseInt(item.due_day, 10) : null,
            key: item.key || item.id || `${index}-${item.account_tocredit}-${item.member_type}`,
          }))
        })
       
        this.setState({extra_deposit_list:res.data.extra_deposit_list===undefined || res.data.extra_deposit_list===null?[]:JSON.parse(res.data.extra_deposit_list) })

    })

    axios.get(serverconfig.backendserverurl+`/api/companyaccounts/?sacco=${sacco}`)
    .then(res => {
        this.setState({
            companyaccounts:res.data
        })
        this.setState({datarequested:false})
    })


    //
    axios.get(serverconfig.backendserverurl+`/api/membertypes/?sacco=${sacco}`)
    .then(res => {
        this.setState({
          membertypes:res.data
        })

        this.setState({datarequested:false})

    })
}

  loadAutopaymentItemForEdit = (item) => {
    const dueMonth = item.due_month ? parseInt(item.due_month, 10) : null;
    const dueDay = item.due_day ? parseInt(item.due_day, 10) : null;
    this.setState({
      editing_autopayment_key: item.key || item.id,
      member_type: item.member_type || '',
      account_tocredit: item.account_tocredit || '',
      totalpayment: parseFloat(item.totalpayment) || 0,
      payment_occurance: item.payment_occurance || 'oneoff',
      charge_mode: item.charge_mode || 'on_deposit',
      due_month: dueMonth,
      due_day: dueDay,
      scheduled_due_date: scheduledDueDateFromParts(dueMonth, dueDay),
      payment_label: item.payment_label || '',
    }, () => {
      const formSection = document.getElementById('autopay-form-section');
      if (formSection) {
        formSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  };

  resetAutopaymentForm = () => {
    this.setState({
      editing_autopayment_key: null,
      member_type: '',
      account_tocredit: '',
      payment_occurance: 'oneoff',
      totalpayment: 0,
      charge_mode: 'on_deposit',
      due_month: null,
      due_day: null,
      scheduled_due_date: null,
      payment_label: '',
    });
  };

  upsertAutopaymentItem = (newitem) => {
    const businessKey = autopaymentBusinessKey(newitem);
    const editingKey = this.state.editing_autopayment_key;
    const autopaymentlist = this.state.autopaymentlist.filter((item) => {
      if (editingKey && (item.key === editingKey || item.id === editingKey)) {
        return false;
      }
      return autopaymentBusinessKey(item) !== businessKey;
    });
    return [...autopaymentlist, newitem];
  };

  getAutopaymentRecordKey = (record) => String((record && (record.key || record.id)) || '');

  persistAutopaymentList = (autopaymentlist, successMessage, reloadPage = false) => {
    this.setState({ datarequested: true, autopaymentlist });

    const form_data = new FormData();
    form_data.append('sacco', sacco);
    form_data.append('autopaymentlist', JSON.stringify(autopaymentlist));

    return axios.post(
      serverconfig.backendserverurl + '/customqueries/createautomamber_payments',
      form_data,
      { headers: { 'content-type': 'multipart/form-data' } }
    )
      .then(() => {
        message.success(successMessage || 'Automated payment rules saved');
        if (reloadPage) {
          window.location.reload(false);
        } else {
          this.setState({ datarequested: false });
        }
      })
      .catch((error) => {
        const errMsg = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Failed to save automated payment rules';
        message.error(errMsg);
        this.setState({ datarequested: false });
      });
  };

  removeAutopaymentItem = (record) => {
    const recordKey = this.getAutopaymentRecordKey(record);
    const updated = this.state.autopaymentlist.filter(
      (item) => this.getAutopaymentRecordKey(item) !== recordKey
    );

    if (updated.length === this.state.autopaymentlist.length) {
      message.error('Could not remove rule. Please refresh and try again.');
      return;
    }

    const wasEditing = this.state.editing_autopayment_key === recordKey;
    if (wasEditing) {
      this.resetAutopaymentForm();
    }

    this.persistAutopaymentList(
      updated,
      updated.length === 0 ? 'Rule deleted. No automated payment rules remain.' : 'Rule deleted.',
      false
    );
  };

  commitAutopaymentItemFromForm = () => {
    if (this.state.member_type === '') {
      message.info('Please select member type');
      return;
    }
    if (this.state.totalpayment <= 0) {
      message.info('Payment cant be less or equal to zero');
      return;
    }
    if (this.state.payment_occurance === '') {
      message.info('Please select payment occurance');
      return;
    }
    if (this.state.account_tocredit === '') {
      message.info('Please select payment account');
      return;
    }
    if (
      this.state.charge_mode === 'scheduled'
      && (!this.state.due_month || !this.state.due_day)
    ) {
      message.info('Please select the annual due date for scheduled fees');
      return;
    }

    const dueMonth = this.state.charge_mode === 'scheduled'
      ? parseInt(this.state.due_month, 10)
      : null;
    const dueDay = this.state.charge_mode === 'scheduled'
      ? parseInt(this.state.due_day, 10)
      : null;

    const itemKey = [
      this.state.charge_mode,
      this.state.account_tocredit,
      this.state.member_type,
      this.state.payment_occurance,
      dueMonth,
      dueDay,
    ].join('-');

    const newitem = {
      id: itemKey,
      key: itemKey,
      member_type: this.state.member_type,
      account_tocredit: this.state.account_tocredit,
      totalpayment: parseFloat(this.state.totalpayment),
      payment_occurance: this.state.payment_occurance,
      charge_mode: this.state.charge_mode,
      due_month: dueMonth,
      due_day: dueDay,
      payment_label: this.state.payment_label || this.state.account_tocredit,
    };

    const wasEditing = !!this.state.editing_autopayment_key;
    const updatedList = this.upsertAutopaymentItem(newitem);
    this.resetAutopaymentForm();
    this.persistAutopaymentList(
      updatedList,
      wasEditing ? 'Rule updated and saved.' : 'Rule added and saved.',
      false
    );
  };

    //////////////////////////////////////////////////
  //handle delete here
  handleDelete = id => {
    axios.delete(`${serverconfig.backendserverurl}/api/membertypes/${id}`).then(res =>{
      window.location.reload(false)
      message.info("successfully deleted") 
     }
     );
  };

getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  this.setState({
    searchText: selectedKeys[0],
    searchedColumn: dataIndex,
  });
};

handleReset = clearFilters => {
  clearFilters();
  this.setState({ searchText: '' });
};

  render() {
    const columns = [
      {
        title: 'Type Name',
        dataIndex: 'type_name',
        key: 'id',
        ...this.getColumnSearchProps('type_name'),
      },
      {
        title: 'Minimum Account Balance',
        dataIndex: 'minimum_savings_balance',
        key: 'id',
      },
      {
        title: 'Deposit charge',
        dataIndex: 'deposit_charges',
        key: 'id',
      },
      {
        title: 'Savings withdraw charge',
        dataIndex: 'savings_withdraw_charges',
        key: 'id',
      },

      {
        title: 'Action',
        dataIndex: 'id',
        key: 'id',
        render: text =>
        <p>
        <Popover content={<p>Click here to edit,view details</p>} title="Edit,View">
         <Link to={`/membertypes/${text}`}><FundViewOutlined style={{color:'blue'}}/></Link>
        </Popover>
        &nbsp;&nbsp;&nbsp;
        <Popover content={<p>Click here to view account opening items</p>} title="View Opening Items">
        <Link to={`/accountopeningitems/${text}`}><FundViewOutlined style={{color:'green'}}/></Link>
        </Popover>
        &nbsp;&nbsp;&nbsp;
        <Popover content={<p>Click here to delete client</p>} title="Delete">
        <Popconfirm title="Sure to delete?" onConfirm={() => this.handleDelete(text)}>
          <DeleteOutlined style={{color:'red'}}/>
         </Popconfirm>
        </Popover>
        </p>,
        
      }

    ];



    const payments_columns = [
      {
        title: 'Item',
        dataIndex: 'account_tocredit',
        key: 'id',
      },
      {
        title: 'Member type',
        dataIndex: 'member_type',
        key: 'id',
      },
      {
        title: 'Total payment',
        dataIndex: 'totalpayment',
        key: 'id',
      },
      {
        title: 'Payment occurance',
        dataIndex: 'payment_occurance',
        key: 'payment_occurance',
      },
      {
        title: 'Charge mode',
        dataIndex: 'charge_mode',
        key: 'charge_mode',
        render: (value) => value === 'scheduled' ? 'Scheduled date' : 'On deposit',
      },
      {
        title: 'Due date',
        key: 'due_date',
        render: (_, record) => formatScheduledDueDate(record),
      },
      {
        title: 'Label',
        dataIndex: 'payment_label',
        key: 'payment_label',
        render: (value, record) => value || record.account_tocredit,
      },

      {
        title: 'Action',
        key: 'action',
        render: (_, record) => (
          <span>
            <Tooltip title="Edit rule">
              <Button
                type="link"
                icon={<EditOutlined />}
                title="Edit rule"
                onClick={() => this.loadAutopaymentItemForEdit(record)}
              />
            </Tooltip>
            <Popconfirm
              title="Delete this rule permanently?"
              okText="Delete"
              okType="danger"
              cancelText="Cancel"
              onConfirm={() => this.removeAutopaymentItem(record)}
            >
              <Button type="link" danger icon={<DeleteOutlined />} title="Delete rule" />
            </Popconfirm>
          </span>
        ),
      }

    ];




    const extradeposit_columns = [
      {
        title: 'Item',
        dataIndex: 'account_tocredit',
        key: 'id',
      },
      {
        title: 'Member type',
        dataIndex: 'member_type',
        key: 'id',
      },
      {
        title: 'Minimum deposit',
        dataIndex: 'minimum_amount',
        key: 'id',
      },


      {
        title: 'Action',
        dataIndex: 'id',
        key: 'id',
        render: text =>
        <p>
        <Popover content={<p>Click here to delete item</p>} title="Delete">
        <Popconfirm title="Sure to delete?" 
        onConfirm={() =>{
        this.setState({ extra_deposit_list:  [...this.state.extra_deposit_list.filter(todo => todo.key
          !==text)]});

        }}>
          <DeleteOutlined style={{color:'red'}}/>
         </Popconfirm>
        </Popover>
        </p>,
        
      }

    ];




    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return(
        <div>

        <Tabs defaultActiveKey="1" onChange={()=>{}}>
          <TabPane tab="Member types" key="001" >
          <Collapse defaultActiveKey={['1']} onChange={this.callback}>
            <Panel header="MEMBER TYPES" key="1">
            <Table 
            columns={columns} 
            scroll={{ x: 1000 }}
            pagination={{showQuickJumper:true,showSizeChanger:true }}
            dataSource={this.state.membertypes} 
            bordered/>
            </Panel>
            </Collapse>
            <br />
            <Collapse defaultActiveKey={['0']} onChange={callback}>
            <Panel header="Collapse Panel to open account type creation Form" key="1">
              <h2>Create new member Type Here</h2>
              <MemberTypeForm 
              requestType="post"
              assetID={null}
              btnText="Create"
              /> 
            </Panel>
            </Collapse>
             </TabPane>





            {/*Automated deductions*/ }
                  <TabPane tab="Automated member payments from savings" key="002" >
                  <h4>Automated fee / subscription rules</h4>
                  <Card id="autopay-form-section">
                  <Alert
                    type="info"
                    showIcon
                    style={{ marginBottom: 16 }}
                    message="Two charge modes"
                    description={
                      <span>
                        <strong>On deposit</strong> — fee is collected whenever the member deposits to savings (existing behaviour).{' '}
                        <strong>Scheduled date</strong> — fee runs automatically every year on the due month/day (daily job at 03:30).
                        Members with enough withdrawable savings are charged; partial payment is supported.
                      </span>
                    }
                  />
                  {this.state.editing_autopayment_key ? (
                    <Alert
                      type="info"
                      showIcon
                      closable
                      style={{ marginBottom: 16 }}
                      message="Editing rule"
                      description="The form below is loaded with the selected rule. Change any field (including the due date), then click Update item to save."
                      onClose={this.resetAutopaymentForm}
                    />
                  ) : (
                    <Alert
                      type="warning"
                      showIcon
                      style={{ marginBottom: 16 }}
                      message="How to add or change a rule"
                      description="Click Edit on a row to load it into the form, or fill the form and click Add item. Delete and Update save immediately."
                    />
                  )}
                  <Form name="autopayform">

               <FormItem label={"Member type"}>
                <Select 
                placeholder="Member type" 
                style={{  }} 
                value={this.state.member_type}
                onChange={(val)=>{this.setState({member_type:val})}} 
                showSearch
                optionFilterProp="children"
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                onSearch={this.onSearch}                    
                >
                  {this.state.membertypes.map(
                    (accnt)=>(
                      <Option value={accnt.type_name}>{accnt.type_name}</Option>
                    ))}
                </Select>
            </FormItem>

            <FormItem label={"Payment Item Account"}>
                <Select 
                placeholder="Account" 
                style={{  }} 
                value={this.state.account_tocredit}
                onChange={(val)=>{this.setState({account_tocredit:val})}} 
                showSearch
                optionFilterProp="children"
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                onSearch={this.onSearch}                    
                >
                  {this.state.companyaccounts.map(
                    (accnt)=>(
                      <Option value={accnt.account_name}>{accnt.account_name} | {accnt.account_code}</Option>
                    ))}
                </Select>
            </FormItem>


            <FormItem 
                label="Total payment">
            <Input name="totalpayment"  type='number' placeholder="Total pay." value={this.state.totalpayment} onChange={(e) => this.setState({ totalpayment: e.target.value})} />                          
            </FormItem>


            <FormItem label={"Payment Occurance"}>
            <Select 
                placeholder="Occurance" 
                style={{  }} 
                value={this.state.payment_occurance}
                onChange={(val)=>{this.setState({payment_occurance:val})}} 
                showSearch
                optionFilterProp="children"
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                onSearch={this.onSearch}                    
                >
                  
                <Option value={'oneoff'}>One off</Option>
                <Option value={"annually"}>Annually</Option>

                </Select>

            </FormItem>

            <FormItem label="Charge mode">
              <Select
                value={this.state.charge_mode}
                onChange={(val) => this.setState({
                  charge_mode: val,
                  due_month: null,
                  due_day: null,
                  scheduled_due_date: null,
                })}
              >
                <Option value="on_deposit">On deposit (when member saves)</Option>
                <Option value="scheduled">Scheduled date (automatic yearly)</Option>
              </Select>
            </FormItem>

            {this.state.charge_mode === 'scheduled' ? (
              <>
                <FormItem
                  label="Annual due date"
                  extra="Fee runs every year on this month and day. The year you pick is for reference only."
                >
                  <DatePicker
                    format="DD/MM/YYYY"
                    style={{ width: '100%' }}
                    placeholder="Select due date (e.g. 06/06/2026)"
                    value={this.state.scheduled_due_date}
                    onChange={(date) => {
                      if (!date) {
                        this.setState({ due_month: null, due_day: null, scheduled_due_date: null });
                        return;
                      }
                      this.setState({
                        due_month: date.month() + 1,
                        due_day: date.date(),
                        scheduled_due_date: date,
                      });
                    }}
                  />
                </FormItem>
                <FormItem label="Payment label (optional)">
                  <Input
                    placeholder="e.g. Annual subscription fee"
                    value={this.state.payment_label}
                    onChange={(e) => this.setState({ payment_label: e.target.value })}
                  />
                </FormItem>
              </>
            ) : null}

            <FormItem>
              <Button type="primary" htmlType="button" onClick={this.commitAutopaymentItemFromForm}>
                {this.state.editing_autopayment_key ? 'Update item' : 'Add item'}
              </Button>
              {this.state.editing_autopayment_key ? (
                <Button style={{ marginLeft: 8 }} onClick={this.resetAutopaymentForm}>
                  Cancel edit
                </Button>
              ) : null}
            </FormItem>

            </Form>
              <br></br>
            <Table 
            columns={payments_columns} 
            rowKey={(record) => this.getAutopaymentRecordKey(record) || `${record.account_tocredit}-${record.member_type}`}
            scroll={{ x: 1000 }}
            pagination={{showQuickJumper:true,showSizeChanger:true }}
            dataSource={this.state.autopaymentlist}
            onRow={(record) => ({
              style: this.getAutopaymentRecordKey(record) === this.state.editing_autopayment_key
                ? { backgroundColor: '#e6f7ff' }
                : {},
            })}
            bordered/>
            <br></br>

          <Button  type="primary" htmlType='button'
          
          onClick={() => {
          this.persistAutopaymentList(this.state.autopaymentlist, 'Automated payment rules saved', true);
          }}
          
          >Save rules</Button>

          <Button
            style={{ marginLeft: 8 }}
            loading={this.state.running_scheduled}
            onClick={() => {
              this.setState({ running_scheduled: true });
              const form_data = new FormData();
              form_data.append('sacco', sacco);
              form_data.append('username', username);
              form_data.append('force_run', 'false');
              axios.post(
                serverconfig.backendserverurl + '/customqueries/run_scheduled_member_payments_now',
                form_data,
                { headers: { 'content-type': 'multipart/form-data' } }
              )
                .then((res) => {
                  const summary = res.data.summary || {};
                  const charged = summary.charged || 0;
                  if (charged > 0) {
                    message.success(`Run complete: ${formatScheduledRunSummary(summary)}`);
                  } else {
                    message.warning(`Run complete: ${formatScheduledRunSummary(summary)}`);
                  }
                  this.setState({ running_scheduled: false });
                })
                .catch(() => {
                  message.error('Scheduled fee run failed');
                  this.setState({ running_scheduled: false });
                });
            }}
          >
            Run scheduled fees due today
          </Button>

          <Popconfirm
            title="Force-run all scheduled rules even if today is not the due date?"
            onConfirm={() => {
              this.setState({ running_scheduled: true });
              const form_data = new FormData();
              form_data.append('sacco', sacco);
              form_data.append('username', username);
              form_data.append('force_run', 'true');
              axios.post(
                serverconfig.backendserverurl + '/customqueries/run_scheduled_member_payments_now',
                form_data,
                { headers: { 'content-type': 'multipart/form-data' } }
              )
                .then((res) => {
                  const summary = res.data.summary || {};
                  const charged = summary.charged || 0;
                  if (charged > 0) {
                    message.success(`Force run complete: ${formatScheduledRunSummary(summary)}`);
                  } else {
                    message.warning(`Force run complete: ${formatScheduledRunSummary(summary)}`);
                  }
                  this.setState({ running_scheduled: false });
                })
                .catch(() => {
                  message.error('Force run failed');
                  this.setState({ running_scheduled: false });
                });
            }}
          >
            <Button style={{ marginLeft: 8 }} danger loading={this.state.running_scheduled}>
              Force run scheduled fees
            </Button>
          </Popconfirm>
           </Card>
      
          </TabPane>






















          {/**other deposit form collection**/}

          <TabPane tab="Other deposit form collections" key="003" >
            <Card>
            <Form name="otherformdeposits">

            <FormItem label={"Member type"}>
                <Select 
                placeholder="Member type" 
                style={{  }} 
                value={this.state.member_type}
                onChange={(val)=>{this.setState({member_type:val})}} 
                showSearch
                optionFilterProp="children"
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                onSearch={this.onSearch}                    
                >
                  {this.state.membertypes.map(
                    (accnt)=>(
                      <Option value={accnt.type_name}>{accnt.type_name}</Option>
                    ))}
                </Select>
            </FormItem>



            <FormItem label={"Payment Item Account"}>
                <Select 
                placeholder="Account" 
                style={{  }} 
                value={this.state.account_tocredit}
                onChange={(val)=>{this.setState({account_tocredit:val})}} 
                showSearch
                optionFilterProp="children"
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                onSearch={this.onSearch}                    
                >
                  {this.state.companyaccounts.map(
                    (accnt)=>(
                      <Option value={accnt.account_name}>{accnt.account_name} | {accnt.account_code}</Option>
                    ))}
                </Select>
            </FormItem>


            <FormItem label="Minimum amount">
            <Input name="totalpayment"  type='number' placeholder="Total pay." value={this.state.totalpayment} onChange={(e) => this.setState({ totalpayment: e.target.value})} />                          
            </FormItem>


            <FormItem>
              <Button  type="primary" htmlType='button' onClick={()=>{

                if (this.state.member_type===''){
                  message.info("Please select member type")
                } else if (this.state.totalpayment<=0){
                  message.info("Minimum cant be less or equal to zero")
                }else if (this.state.account_tocredit===''){
                  message.info("Please select payment account")
                }else{

                    var newitem={
                      'id':this.state.account_tocredit+this.state.member_type,
                      'key':this.state.account_tocredit+this.state.member_type,
                      'account_tocredit':this.state.account_tocredit,
                      'member_type':this.state.member_type,
                      'minimum_amount':this.state.totalpayment,
                      'amount_paid':0
                    }

                    //add to shedule object
                      this.setState({
                        extra_deposit_list: [...this.state.extra_deposit_list, newitem]
                      });

                      this.setState({account_tocredit:''})
                      this.setState({member_type:''})
                      this.setState({totalpayment:0})

                 
                  }

              }}>Add item</Button>
            </FormItem>

            </Form>
              <br></br>
            <Table 
            columns={extradeposit_columns} 
            scroll={{ x: 1000 }}
            pagination={{showQuickJumper:true,showSizeChanger:true }}
            dataSource={this.state.extra_deposit_list} 
            bordered/>
            <br></br>

          <Button  type="primary" htmlType='button'
          
          onClick={()=>{

          this.setState({datarequested:true})

          //get last slip number
          let form_data = new FormData();

          form_data.append('sacco', sacco);
          form_data.append('extra_deposit_list', JSON.stringify(this.state.extra_deposit_list));

          axios.post(serverconfig.backendserverurl+'/customqueries/createextra_deposits', form_data, {
            headers: {
              'content-type': 'multipart/form-data'
            }
            })
          .then(res => {
              window.location.reload(false)
              this.setState({datarequested:false})
          })
          .catch(error => console.log(error))

          }}
          
          >Update deposit extra list</Button>              

          </Card>
          </TabPane>


      </Tabs>

        </div>
    )

    }

    
  }
}

export default MemberTypeList; 
